import { MODE_DELIVERY, MODE_TAKEAWAY } from "../constants/constants";
import {
    AllergenPayload,
    Cmp,
    CommandGroupProduct,
    CreateDeliveryRequest,
    EcranPayload,
    OrderPayload,
    PayOp,
    Personel,
    ProductCategory,
    Remise,
} from "../interfaces/apiPayloads";
import {
    Allergen,
    CategoryItem,
    OrderSummary,
    Restaurant,
    RestaurantCart,
    Screen,
    SelectedArticle,
    SelectedIngredient,
    TVA,
} from "../interfaces/Catalogue";
import { CodePromoSuggestion, LoyalityGroup, PanierDiscount } from "../interfaces/loyality.interface";
import { UserInfo } from "../interfaces/user";
import { extractClientAddress } from "../utils/deliveryUtils";
import {
    calculateTotalLoyaltyPtsConsumedForMenuOrArticle,
    calculateTotalLoyaltyPtsConsumedForOrder,
    isPurchaseOfferActive
} from "../utils/loyaltyUtils";
import { getTvaByOrderType } from "../utils/orderUtils";
import {
    calculateItemTotalPrice,
    calculateSelectedArticlesPrice,
    findPriceByTypeOrder,
    getPaidFreeCounts,
    getPriceByTypeOrderForComposition
} from "../utils/priceUtils";

const TypeCmdEmpValues = {
    delivery: 10,
    other: 8,
};

export const CONFIG = {
    IdUser: 2,
    TypeCmdApp: 2,
};

function createAppliedPromotion(
    isApplied: boolean,
    suggestion?: CodePromoSuggestion | null,
    restaurantCart?: RestaurantCart | null,
): any | null {

    if (!isApplied || !suggestion) {
        return null;
    }

    const {
        id: i,
        designation: n,
        beginDate: dd,
        endDate: df,
        cartThreshold: s,
        discountValue: g,
        isMultiple: im,
        discountType,
        beginHour: hd,
        endHour: hf,
        message: csmsg,
    } = suggestion;

    return {
        i,
        n,
        dd,
        df,
        s,
        g,
        ia: true,
        im,
        ip: discountType === 0,
        hd,
        hf,
        mc: null,
        cu: null,
        sn: false,
        ex: false,
        us: false,
        ap: true,
        csmsg,
        idResto: restaurantCart?.restaurant?.id,
    };
}


function createClientPayload({
    userLoyalityPoints,
    userInfo,
    completeAddress = "",
    createDeliveryRequest,
    restaurant,
    groupDiscount = null,
}: {
    userLoyalityPoints: number;
    userInfo: UserInfo;
    completeAddress?: string;
    createDeliveryRequest?: CreateDeliveryRequest;
    restaurant?: Restaurant | null;
    groupDiscount?: LoyalityGroup | null;
}): any {

    const { clientAddress } = createDeliveryRequest || {};
    const {
        firstName = "",
        lastName = "",
        email = "",
        phoneNumber = "",
    } = userInfo

    return {
        FideliteCumul: userLoyalityPoints,
        Nm: `${firstName} ${lastName}`.trim(),
        T: phoneNumber,
        Eml: email,
        Ad: completeAddress,
        Cc: clientAddress?.zip_code,
        B: clientAddress?.appartement,
        In: "",
        Es: "",
        PortePo: "",
        IdClientFioFid: userInfo.id,
        TotalFidelite: restaurant?.totalLoyaltyPt || 0,
        F: userLoyalityPoints,
        SecretKey: userInfo.qrCodeValue,
        FidGrp: {
            ...groupDiscount
        }
    };
}



export const mapToOrderPayload = (
    restaurantCart: RestaurantCart,
    restaurant: Restaurant,
    totalOrder: number,
    isOnlinePaymentChecked: boolean,
    isMaintenantChecked: boolean,

    isPanierDiscountApplied: boolean,
    isPromoCodeApplied: boolean,
    isPromoGroupApplied: boolean,


    prepareFor: string | null,
    userInfo: any,
    finalTotal: number,
    userLoyalityPoints: number,
    createDeliveryRequest?: CreateDeliveryRequest,
    completeAddress?: string,
    discountAmount?: number,

    codePromoSuggestion?: CodePromoSuggestion | null,
    panierDiscount?: PanierDiscount | null,
    groupDiscount?: LoyalityGroup | null,
    fees?: number,
): OrderPayload => {
    const isTotalDiscountApplied =
        isPanierDiscountApplied || isPromoCodeApplied || isPromoGroupApplied;

    const commandGroupProducts = mapToCommandGroupProducts(
        restaurantCart,
        isMaintenantChecked,
        isPanierDiscountApplied,
        isPromoCodeApplied,
        isPromoGroupApplied,
        finalTotal,
        discountAmount || 0,
        panierDiscount?.cartRewardDiscountType
    );

    const date = new Date().toISOString();

    // const payOps: PayOp[] = [
    //     {
    //         IdD: 0,
    //         IdType: 2,
    //         Name: isOnlinePaymentChecked ? "Online" : "Espèces",
    //         Value: 93,
    //         IsLock: false,
    //         IsRbs: false,
    //         IsAnnuled: false,
    //         IsNnEdt: false,
    //         IsAuto: false,
    //         IdAvOrigin: 0,
    //         CodeTr: null,
    //         TpeTicket: null,
    //         TpeNumMsg: 0,
    //         TpeMsg: null,
    //         TpeType: null,
    //         TicketCommercant: null,
    //     },
    // ];

    const client = createClientPayload(
        {
            userLoyalityPoints,
            userInfo,
            completeAddress,
            createDeliveryRequest,
            restaurant,
            groupDiscount
        }
    )


    const remise: Remise = {
        IdD: 0,
        Id: 0,
        IsPct: false,
        IsValid: isTotalDiscountApplied ? true : false,
        Amount: isTotalDiscountApplied ? discountAmount ?? 0 : 0,
        Min: 0.0,
    };

    const personel: Personel = {
        i: 0,
        u: null,
        r: 0.0,
    };

    const appliedPromotion =
        createAppliedPromotion(
            isPromoCodeApplied,
            codePromoSuggestion,
            restaurantCart
        );

    const deliveryFees = fees || 0;
    const orderInfo = {
        IdTypePv: 2,
        IdRestaurant: restaurant.id,
        IdUser: CONFIG.IdUser,
        IdMachine: 51,
        IdBeeper: 0,
        IdCommand: 0,
        TakeAway: [MODE_TAKEAWAY, MODE_DELIVERY].includes(restaurantCart?.mode ?? 0),
        ToBeDelivered: restaurantCart?.mode == MODE_DELIVERY,
        TotalNet: finalTotal - deliveryFees,
        TotalCommand: finalTotal - deliveryFees,
        PanierEncaisse: finalTotal - deliveryFees,
        PanierApayer: 0,
        PanierArendre: 0,
        ClientPsdName: null,
        TypeCmdApp: CONFIG.TypeCmdApp,
        TypeCmdEmp:
            restaurantCart.mode == MODE_DELIVERY
                ? TypeCmdEmpValues.delivery
                : TypeCmdEmpValues.other,
        TypeCmdLivTiers: 0,
        DecalageCmdDt: prepareFor,
        DecalageCmdKtcMin: 0,
        Client: client,
        CommandGroupProducts: commandGroupProducts,
        // "PayOps": payOps,
        PayOps: null,
        Remise: remise,
        DeliveryIdClientAddress: 0,
        NumCaisse: 0,
        FideliteTotalPointsProd: 0,
        FideliteTotalPointsRetrait: isPanierDiscountApplied
            ? panierDiscount?.cartRewardTotalPtRequired
            : calculateTotalLoyaltyPtsConsumedForOrder(restaurantCart.categories),
        AppliedPromotion: appliedPromotion,
        IsPromotionApplied: isPromoCodeApplied,
        IsRemiseApplied: false,
        Chevalet: null,
        PhoneNumber: userInfo?.phoneNumber,
        ToBeCollectedViaDrive: false,
        IdLanguage: 0,
        Id: 0,
        CommandDate: date,
        DatemajPrete: date,
        NumCmd: 0,
        IsPrete: false,
        IsDeleted: false,
        IsTotallyPrepared: false,
        IsLivred: false,
        DateLivraison: null,
        Location: "Mobile/Web",
        IsPriority: false,
        IsAsuivrePlustard: false,
        CanShowKitchen: true,
        IsPaid: true,
        Personel: personel,
        IsRepas: false,
        Annuled: null,
        IsMobile: false,
        PaymentDate: date,
        IdChangePvt: 0,
        CountUpdate: 0,
        IdClient: 0,
        FIDAPP: isPanierDiscountApplied,
    };

    return orderInfo;
};


const duplicateCategoriesWithPurchaseOffers = (
    categories: CategoryItem[] | undefined | null
): CategoryItem[] => {
    if (!categories?.length) return [];

    return categories.flatMap((category) => {
        /** MENU categories: keep unchanged. */
        const allSelectedArticles =
            category.order?.flatMap((orderItem) => orderItem.selectedArticles) ?? [];

        if (allSelectedArticles.length > 0) {
            return category; // already a Menu → no duplication
        }

        /** ARTICLE categories: possibly duplicate based on purchase offers. */
        const qty = category.quantity ?? 1;
        const { paid, free } = getPaidFreeCounts(category.purchaseOffers, qty);

        if (!isPurchaseOfferActive(category.purchaseOffers)) {
            return category; // offers not active → return as‑is
        }

        const duplicate = (count: number, makeCopy: (c: CategoryItem) => CategoryItem) =>
            Array.from({ length: count }, () => makeCopy({ ...category, quantity: 1 }));

        /** Build free and paid duplicates, then merge. */
        const freeCopies = duplicate(free, (c) => {
            c.discountedPrice = c.finalUnitPrice ?? 0;
            c.isFree = true;
            return c;
        });

        const paidCopies = duplicate(paid, (c) => c);

        return [...freeCopies, ...paidCopies];
    });
}

export const mapToCommandGroupProducts = (
    restaurantCart: RestaurantCart,
    isMaintenantChecked: boolean,
    isPanierDiscountApplied: boolean,
    isPromoCodeApplied: boolean,
    isPromoGroupApplied: boolean,
    finalTotal: number,
    discountAmount: number,
    panierRewardDiscountType?: number
): CommandGroupProduct[] => {
    const { categories, mode } = restaurantCart;
    const isTotalDiscountApplied =
        isPanierDiscountApplied || isPromoCodeApplied || isPromoGroupApplied;
    const priceWithoutDicount = finalTotal + discountAmount;

    const commandGroupProducts: CommandGroupProduct[] = [];
    const discountPercentage = parseFloat(
        ((discountAmount / priceWithoutDicount) * 100).toFixed(2)
    );

    const mappedCategories = duplicateCategoriesWithPurchaseOffers(categories);

    mappedCategories?.map((category, index) => {
        const allSelectedArticles =
            category?.order?.flatMap((orderItem) => orderItem.selectedArticles) || [];

        const date = new Date().toISOString();
        const categoryTVA = getTvaByOrderType(mode, category);
        const nameMenu =
            allSelectedArticles[0]?.selectedMenuItem.name || category.designation;

        const totalGroupPrice =
            (category?.finalUnitPrice ?? 0) * (category?.quantity || 1);

        const totalMenu = isTotalDiscountApplied
            ? parseFloat(
                (totalGroupPrice * (1 - discountPercentage / 100)).toFixed(2)
            )
            : category?.discountedPrice
                ? category?.discountedPrice
                : category?.finalUnitPrice || 0;

        const groupRemiseFinalPct = isTotalDiscountApplied ? discountPercentage : 0;

        const totalPriceWithFreeArticles = calculateSelectedArticlesPrice(
            allSelectedArticles,
            mode,
            false,
            false
        );

        const groupRemiseMt =
            totalPriceWithFreeArticles > totalMenu
                ? parseFloat((totalPriceWithFreeArticles - totalMenu).toFixed(2))
                : isTotalDiscountApplied
                    ? parseFloat((totalGroupPrice - totalMenu).toFixed(2))
                    : parseFloat(
                        (category?.discountedPrice
                            ? (category?.finalUnitPrice || 0) - category?.discountedPrice
                            : 0
                        ).toFixed(2)
                    );

        let orderGroup: CommandGroupProduct = {
            NameMenu: nameMenu,
            Identity: `G${index + 1}`,
            Quantity: category?.quantity || 1,
            TotalMenu: totalMenu,
            IsOffred: false,
            GroupRemisePct: 0,
            GroupRemiseMt: groupRemiseMt,
            GroupRemiseFinalPct: groupRemiseFinalPct,
            GroupRemiseFinalMt: groupRemiseMt,
            CcnOptimiz: true,
            IdCategory: category?.id,
            DateMiseJour: date,
            UpdateMaj: true,
            ProductCategory: [],
            HasAllergene: category?.hasAllergene || false,
            Allergenes: mapAllergenes(category?.articleAllergen ?? []),
            IsFideliteApplied: !panierRewardDiscountType,
            Symbol: null,
            IdTva: categoryTVA?.id,
            Tva: categoryTVA?.taux,
            IdGroup: 0, //FIXME:
            DispchDateMaj: date,
            DispchDateLock: date,
            DispchIdUser: 0,
            DispchGroupTypePrior: 0,
            DispchIsPrete: false,
            KitchenFrColor: category.kitchenFrColor,
            CuisineInfo: null,
        };

        //isArticle
        if (allSelectedArticles.length == 0) {
            orderGroup.ProductCategory = orderGroup.ProductCategory || [];
            orderGroup.ProductCategory.push(
                buildProductCategoryArticle(
                    category,
                    mode,
                    categoryTVA,
                    isTotalDiscountApplied
                )
            );
        } else {
            //isMenu
            orderGroup.ProductCategory = orderGroup.ProductCategory || [];
            allSelectedArticles?.map((selectedArticle, index) => {
                orderGroup.ProductCategory?.push(
                    buildProductCategoryMenuItem(
                        selectedArticle,
                        category,
                        mode,
                        isTotalDiscountApplied,
                        discountPercentage,
                        index
                    )
                );
            });
        }

        commandGroupProducts.push(orderGroup);
    });

    return commandGroupProducts;
};

export const mapIngredient = (
    selectedIngredients: SelectedIngredient[],
    eliminatedIngredients: SelectedIngredient[],
    typeOrder: number
): Cmp[] => {
    const nonIncludedIngredients = selectedIngredients?.filter(
        (ingredient) => ingredient.ingredient.inclus === false
    );
    const mergedIngredients = [
        ...nonIncludedIngredients,
        ...eliminatedIngredients,
    ];

    return mergedIngredients?.map((selectedIngredient, index): Cmp => {
        const { ingredient, quantity } = selectedIngredient;
        const tva = getTvaByOrderType(typeOrder, ingredient);

        return {
            IdD: 0,
            IdRef: ingredient.id,
            Name: ingredient.name,
            Image: ingredient.imageUrl,
            IsActive: ingredient.isActif,
            Price: getPriceByTypeOrderForComposition(typeOrder, ingredient),
            MaxSelect: ingredient.maxNbrSelection,
            Quantity: quantity,
            DefaultEtat: selectedIngredient.quantity === 0 ? true : false,
            PccTotalRemisePct: 0,
            PccTotalRemiseMt: 0,
            BckColor: null,
            FrontColor: null,
            OrderIndex: ingredient.orderIndex,
            HasAllergene: (ingredient.allergen?.length ?? 0) > 0,
            Allergenes: mapAllergenes(ingredient?.allergen ?? []),
            IdTva: tva?.id,
            Tva: tva?.taux,
        };
    });
};

export const mapAllergenes = (allergenes: Allergen[]): AllergenPayload[] => {
    return allergenes?.map(({ id, name, imageUrl }) => {
        return {
            Id: id,
            Name: name,
            ImageUrl: imageUrl,
            Annuler: false,
            IsDeleted: false,
        };
    });
};

export const mapScreens = (screens: Screen[]): EcranPayload[] | null => {
    if (!screens) return [];

    return screens?.map((screen) => {
        return {
            Id: screen.id,
            Nm: screen.designation,
            CanAffichCmdNonPrete: screen.canShowNotReadyOrder,
            IsPreteAffich: screen.canShowReadyOrder,
            EcranCanAffichCmdAnticip: screen.canShowAnticipateOrder,
            IsAffichDispatch: screen.activateDispatching,
            IsDefaultEcran: false,
            DispGroupAffNonPrete: screen.showNotReadyGroup,
            DispGroupAffPrete: screen.showReadyGroup,
            DispGroupAffOneMaj: false,
            TypeCmdAfficher: 0,
            CanAffPrQt: false,
            CanAffCpQt: false,
            canAffInEcrPrepGnrQt: false,
            affInEcrPrepGnrBcGrColor: null,
        };
    });
};

export const mapToOrderSummary = (
    categories: CategoryItem[],
    orderType: number
): OrderSummary[] => {
    return categories?.map((category) => {
        const totalLoyaltyPtsConsumed =
            calculateTotalLoyaltyPtsConsumedForMenuOrArticle(category);

        const amountAfterDiscount = calculateItemTotalPrice(
            category,
            orderType,
            true
        );
        const amount = (category?.finalUnitPrice ?? 0) * (category.quantity ?? 0);

        return {
            item: category.designation,
            quantity: category.quantity ?? 0,
            purchasinOfferedId: category.purchaseOffers?.id ?? null,
            unitPrice: category.finalUnitPrice ?? 0,
            totalLoyaltyPtsConsumed: totalLoyaltyPtsConsumed,
            amount: amount,
            amountAfterDiscount:
                amountAfterDiscount == amount ? null : amountAfterDiscount,
        };
    });
};

export const mapToCreateDeliveryRequest = (
    deliveryAddress: google.maps.places.PlaceResult | undefined,
    quoteId: string,
    userInfo: UserInfo,
    estimatedDeliveryQuoteMinutes: number
): CreateDeliveryRequest => {
    const clientAddress = extractClientAddress(deliveryAddress || {});
    const location = deliveryAddress?.geometry?.location;
    let lat: number = 0;
    let lng: number = 0;

    if (location) {
        if (
            typeof location.lat === "function" &&
            typeof location.lng === "function"
        ) {
            lat = location.lat();
            lng = location.lng();
        } else {
            lat = (location?.lat as any) ?? 0;
            lng = (location?.lng as any) ?? 0;
        }
    }

    return {
        quoteId: quoteId,
        clientLatitude: lat,
        clientLongitude: lng,
        clientAddress,
        clientPhoneNumber: userInfo.phoneNumber || "",
        clientName: `${userInfo.firstName} ${userInfo.lastName}`,
        orderDeliveryBeginDate: new Date().toISOString(),
        estimatedDeliveryQuoteMinutes: Math.floor(estimatedDeliveryQuoteMinutes),
    };
};

const calculateDiscountPercentage = (
    discountAmount: number,
    originalPrice: number
): number => {
    if (originalPrice === 0) return 0;
    return parseFloat(((discountAmount / originalPrice) * 100).toFixed(2));
};

function calculateTotals(
    commandGroup: CommandGroupProduct,
    totalGroupPrice: number
): { TotalMenu: number; GroupRemiseMt: number } {
    // Calculate the total discount per menu
    let totalDiscountPerMenu = 0;
    commandGroup.ProductCategory.forEach((product, index) => {
        totalDiscountPerMenu += product.PcRemiseMontant * product.Quantity;
    });

    // Calculate GroupRemiseMt (total discount for the entire group)
    const groupRemiseMt = totalDiscountPerMenu * commandGroup.Quantity;

    // Calculate TotalMenu (net amount for the entire group)
    const totalMenu = totalGroupPrice - groupRemiseMt;

    return {
        TotalMenu: totalMenu,
        GroupRemiseMt: groupRemiseMt,
    };
}

export const buildProductCategoryArticle = (
    category: CategoryItem,
    mode: number,
    categoryTVA: TVA,
    isTotalDiscountApplied: boolean
) => {
    const price = category.unitPrice || 0;

    const pcRemisePCT = isTotalDiscountApplied ? 0 : category.rewardDiscountValue;

    const discountPriceWithoutIngredient =
        (category.discountedPrice ?? 0) - (category.totalIngredientCost ?? 0);

    const pcTotalRemiseMt = isTotalDiscountApplied
        ? 0
        : category.discountedPrice
            ? price - discountPriceWithoutIngredient
            : 0;

    const { paid, free } = getPaidFreeCounts(
        category.purchaseOffers,
        category.quantity || 1
    );

    return {
        IdD: 0,
        IdRef: category.idRef,
        Name: category.designation,
        ImageUrl: category.imgUrl,
        IdFamily: category.categoryId,
        HsCmp: category.hasComposition || false,
        Price: price,
        Quantity: 1,
        Cmps: mapIngredient(
            category.selectedIngredients || [],
            category.eliminatedIngredients || [],
            mode
        ),
        HasAllergene: category.hasAllergene || false,
        CmpMxSlct: category.maxNbrSelectionComposition || 0,
        Symbol: undefined,
        IdTva: categoryTVA?.id,
        Tva: categoryTVA?.taux,
        Ecrans: category.screens == null ? [] : mapScreens(category.screens),
        IdPrds: category.id,
        KitchenFrColor: category.kitchenFrColor,
        IdType: category.familyId,
        TypeName: category.familyName,
        IdSubType: category.subFamilyId,
        SubTypeName: category.subFamilyName,
        ListeMenu: category.listeMenus,

        // ordering / grouping
        OrderIndex: 0,
        NotImportant: false,
        IdCategory: 0,
        IdLevel: 0,

        // Fidelite
        PcRemisePct: pcRemisePCT,
        PcRemiseMontant: pcTotalRemiseMt,
        PcTotalRemisePct: pcRemisePCT,
        PcTotalRemiseMt: pcTotalRemiseMt,

        PcFidelitePointsRetrait: category.rewardTotalPtRequired,
        CpFidelitePointsRetrait: category.isRemiseActive
            ? category.rewardTotalPtRequired
            : 0,

        PcFidelitePointsPrice: pcTotalRemiseMt,
        CpFidelitePointsPrice: category.isRemiseActive ? pcTotalRemiseMt : 0,

        PcFidelitePointsProd: 0,
        CpFidelitePointsProd: 0,

        // Achat / Offre

        OffertAchatId: category.purchaseOffers?.id || 0,
        OffertNbAchete: category.purchaseOffers?.nbPurchased || 0,
        OffertNbOffert: category.purchaseOffers?.nbOffered || 0,
        OfIsApply:
            !!category.purchaseOffers?.beginDate && !!category.purchaseOffers?.endDate
                ? new Date(category.purchaseOffers.beginDate) <= new Date() &&
                new Date(category.purchaseOffers.endDate) >= new Date()
                : false,


        // static fields
        ...staticProductFields,
    };
};

export const buildProductCategoryMenuItem = (
    selectedArticle: SelectedArticle,
    category: CategoryItem,
    mode: number,
    isTotalDiscountApplied: boolean,
    discountPercentage: number,
    index: number
) => {
    const { selectedMenuItem, selectedIngredients, eliminatedIngredients } =
        selectedArticle;
    const tva = getTvaByOrderType(mode, selectedMenuItem);
    const price =
        findPriceByTypeOrder(selectedMenuItem.typeOrderPrices, mode) || 0;

    const isPurchaseOffersApplied = selectedMenuItem.isFree;

    const pcRemisePCT = isPurchaseOffersApplied
        ? 100
        : isTotalDiscountApplied
            ? 0
            : selectedMenuItem?.rewardDiscountValue;

    const PcTotalRemiseMt = isPurchaseOffersApplied
        ? price
        : isTotalDiscountApplied
            ? parseFloat((price * (discountPercentage / 100)).toFixed(2))
            : selectedMenuItem.discountedPrice
                ? price - selectedMenuItem.discountedPrice
                : 0;

    const productCategoryItem: ProductCategory = {
        IdD: 0,
        IdRef: selectedMenuItem?.levelArticleId,
        Name: selectedMenuItem?.name,
        ImageUrl: selectedMenuItem?.imageUrl,
        IdFamily: selectedMenuItem?.idCategory,
        IdCategory: selectedMenuItem?.idMenu,
        IdLevel: selectedMenuItem.levelId,
        NotImportant: selectedMenuItem.isNotImportant,
        HsCmp: category.hasComposition || false,
        Quantity: selectedMenuItem.quantity || 1,
        Price: price,
        OrderIndex: index,
        // OrderIndex: selectedMenuItem?.orderIndex,
        Cmps: mapIngredient(selectedIngredients, eliminatedIngredients, mode),
        HasAllergene: selectedMenuItem?.articleAllergen?.length > 0,
        Allergenes: mapAllergenes(selectedMenuItem?.articleAllergen ?? []),
        CmpMxSlct: 0,
        Symbol: undefined,
        IdTva: tva?.id,
        Tva: tva?.taux,
        Ecrans:
            selectedMenuItem?.screens == null
                ? []
                : mapScreens(selectedMenuItem?.screens),

        IdPrds: selectedMenuItem.id,
        KitchenFrColor: selectedMenuItem?.kitchenColor,
        IdType: selectedMenuItem?.familyId,
        TypeName: selectedMenuItem?.familyName,
        IdSubType: selectedMenuItem?.subFamilyId,
        SubTypeName: selectedMenuItem?.subFamilyName,
        NiveauName: selectedMenuItem?.levelName,
        ListeMenu: category?.listeMenus,

        // Fidelite
        PcRemisePct: pcRemisePCT,
        PcRemiseMontant: PcTotalRemiseMt,
        PcTotalRemisePct: pcRemisePCT,
        PcTotalRemiseMt: PcTotalRemiseMt,

        PcFidelitePointsRetrait: selectedMenuItem.rewardTotalPtRequired,
        CpFidelitePointsRetrait: selectedMenuItem.isRemiseActive
            ? selectedMenuItem.rewardTotalPtRequired
            : 0,

        PcFidelitePointsPrice: PcTotalRemiseMt,
        CpFidelitePointsPrice: selectedMenuItem.isRemiseActive ? PcTotalRemiseMt : 0,

        PcFidelitePointsProd: 0,
        CpFidelitePointsProd: 0,

        //  Achat / Offre
        OffertAchatId: selectedMenuItem.purchaseOffers?.id || 0,
        OffertNbAchete: selectedMenuItem.purchaseOffers?.nbPurchased || 0,
        OffertNbOffert: selectedMenuItem.purchaseOffers?.nbOffered || 0,
        OfIsApply:
            !!selectedMenuItem.purchaseOffers?.beginDate && !!selectedMenuItem.purchaseOffers?.endDate
                ? new Date(selectedMenuItem.purchaseOffers.beginDate) <= new Date() &&
                new Date(selectedMenuItem.purchaseOffers.endDate) >= new Date()
                : false,

        // isPurchaseOffersApplied,

        // static fields
        ...staticProductFields,
    };

    return productCategoryItem;
};

const staticProductFields = {
    DispatchEtatTypeLigne: 0,
    RewardDiscountType: 1,

    Weight: 0,

    CanAffProductInEcrPrepGnrQt: false,
    IsTotallyPrepared: false,
    CanBeUpdated: false,
    OffertIsPct: false,
    IsForLater: false,
    HasFlOp: false,
    IsOfr: false,
};
